import texts from './sharedmoments.texts'

class SharedmomentsController {
    constructor($scope, $state, $stateParams, SharedMoments, User, Category, Loader) {
        this.name = 'sharedmoments'

        this.$scope = $scope
        this.$state = $state
        this.$stateParams = $stateParams
        this.SharedMoments = SharedMoments
        this.User = User
        this.Category = Category
        this.Loader = Loader

        this.posts = []
        this.categories = Category.getCategories()
        this.selectedCategories = []
        this.urls = []
        this.isLoading = false
        this.postsCount = 0
    }

    $onInit () {
        // Set user if logged in
        this.setActiveUser()

        this.render()

        // GET posts on page load
        if (this.$stateParams.search) {
            this.searchPosts(this.urls)
        }

        // Catch scroll event to load posts on scroll
        this.scroll()

        // Watch
        this.watchCategories()
        this.watchPosts()
        this.watchLanguage()
    }

    setActiveUser () {
        this.User.getCurrentUser()
            .then((user) => {
                this.user = user
            })
            .catch(() => {
                this.user = null
            })
    }

    render () {
        this.language = localStorage.getItem('tourists_lang') || 'EN'

        const {
            MY_BOOK,
            LOG_OUT,
            GENERATE,
            PERSONAL_GUIDEBOOK,
            BEEN_IN_GEORGIA,
            ARE_YOU_CONTRIBUTOR_ONE,
            ARE_YOU_CONTRIBUTOR_TWO,
            NOT_FOUND,
            MORE
        } = texts[this.language]

        this.myBook = MY_BOOK
        this.logoutText = LOG_OUT
        this.generate = GENERATE
        this.personalGuidebook = PERSONAL_GUIDEBOOK
        this.beenInGeorgia = BEEN_IN_GEORGIA
        this.areYouContributorOne = ARE_YOU_CONTRIBUTOR_ONE
        this.areYouContributorTwo = ARE_YOU_CONTRIBUTOR_TWO
        this.notFound = NOT_FOUND
        this.more = MORE
    }

    searchPosts (urls) {
        this.isLoading = true

        this.SharedMoments.searchPosts(this.$stateParams.search, urls)
            .then(({
                data
            }) => {
                const {
                    count,
                    posts
                } = data

                this.postsCount = count

                this.Loader.loadImages(posts, 'photoUrl', () => {
                    this.isLoading = false
                    this.SharedMoments.addPosts(posts)

                    if (posts.length > 0) {
                        this.$scope.$apply()
                    }
                })
            })
            .catch((err) => {
                console.log('Error occured in method searchPosts', err)

                this.error = err.data
            })
    }

    getPosts (categories, urls) {
        this.isLoading = true

        this.SharedMoments.getPosts(categories, urls)
            .then(({
                data
            }) => {
                const {
                    count,
                    posts
                } = data

                this.postsCount = count

                this.Loader.loadImages(posts, 'photoUrl', () => {
                    this.isLoading = false
                    this.SharedMoments.addPosts(posts)

                    if (posts.length > 0) {
                        this.$scope.$apply()
                    }
                })
            })
            .catch((err) => {
                console.log('Error occured in method getPosts', err)

                this.error = err.data
            })
    }

    showPost (event, id) {
        const mcactionbutton = $(event.target).closest('.mcactionbutton').get(0)
        const readmore = $(event.target).closest('.read-more').get(0)
        const readless = $(event.target).closest('.read-less').get(0)

        if (!mcactionbutton && !readmore && !readless) {
            this.$state.go('home.post', {
                id
            })
        }
    }

    scroll () {
        const div = document.getElementsByClassName('cards-container')
        const elem = angular.element(div)

        const that = this
        const diff = 25

        elem.bind('scroll', function scrolling () {
            if (Math.ceil(this.scrollTop + this.clientHeight) + diff >= this.scrollHeight && !that.isLoading && that.postsCount > that.posts.length) {
                that.isLoading = true
                if (that.$stateParams.search) {
                    that.searchPosts(that.urls)
                } else {
                    that.getPosts(that.selectedCategories, that.urls)
                }
            }
        })
    }

    goToMyBook () {
        const bookId = localStorage.getItem('tourists_bookId')

        this.$state.go('home.book.bookStep3', {
            bookId
        }, { reload: true })
    }

    logout () {
        this.User.logout()
    }

    viewMorePosts () {
        if (this.$stateParams.search) {
            this.searchPosts(this.urls)
        } else {
            this.getPosts(this.selectedCategories, this.urls)
        }
    }

    watchCategories () {
        this.$scope.$watch(() => this.Category.getSelectedCategories(), (newValue) => {
            this.selectedCategories = newValue
            this.urls = []

            this.SharedMoments.setPosts([])

            if (!this.$stateParams.search) {
                this.getPosts(this.selectedCategories, this.urls)
            }
        })

        this.$scope.$watch(() => this.User.getUser(), (newValue) => {
            this.user = newValue
        })
    }

    watchPosts () {
        this.$scope.$watch(() => this.SharedMoments.getLoadedPosts(), (newValue) => {
            if (newValue) {
                this.posts = newValue
                this.urls = newValue.map(item => item.url)
            }
        })
    }

    watchLanguage () {
        this.$scope.$watch(() => localStorage.getItem('tourists_lang'), (newValue, oldValue) => {
            if (newValue && newValue !== oldValue) {
                this.render()
            }
        })
    }
}

SharedmomentsController.$inject = ['$scope', '$state', '$stateParams', 'SharedMoments', 'User', 'Category', 'Loader']

export default SharedmomentsController



// WEBPACK FOOTER //
// ./client/app/components/home/sharedmoments/sharedmoments.controller.js